import React, {Component} from 'react';

//libraries
import { CSSTransition } from 'react-transition-group';

//scss
import layerLayoutStyles from '../../static/css/pageStyleModules/layerLayoutStyles.module.scss';
import modalStyles from '../../static/css/componentStyleModules/modalBase.module.scss';


//controller
import MemberControllerAPI from '../../controllers/API/MemberControllerAPI.js';

//components
import MemberGridListComponent from '../components/MemberGridListComponent';
import MemberInfoSheet from '../components/MemberInfoSheetComponent';
import MemberEditAndAddMode from './MemberEditAndAddMode';
import SvgIconBaseComponent from '../svgIconComponents/SvgIconBaseComponent';
import DialogComponent from '../components/DialogComponent';


export default class MemberDisplay extends Component {

    constructor(props){
        super(props);
        this.state = {
            isLoaded:false,
            workMode:'displayMode',

            members:[],
            currentMemberData:{},
            memberIdToEdit:undefined,

            membersReserve:[],

            isEditAddMode:false,

            isDeleteDialogShown:false,

            //manupilateLayer
            manipulateLayerState:'loading',

            //swipe用位置情報
            touchStartY:0,
            touchEndY:0,

        }
    }

    componentWillMount(){
        this.getList()
        .then(() => {
            process.nextTick(() => {
                this.setState({manipulateLayerState:'max'});            
            })
        }).catch(() => {

        });
    }

    getList = () => {
        return new Promise((resolve,reject) => {
            //member情報を取得
            MemberControllerAPI.index()
            .then((result) => {
                this.setState({members:result.data});
                resolve();
            })
            .catch(function(error){
                console.log(error.message);
                reject();
            });
            
        })
    }

    memberDataChange = (memberData) => {
        this.setState({currentMemberData:memberData});
        this.manipulateLayerModeChange('minimum');
    }

    //editAndAdd
    addWindowShow = (event) => {
        event.stopPropagation();        
        this.setState({memberIdToEdit:undefined})
        this.setState({isEditAddMode:true});
    }

    editWindowShow = (event) => {
        this.setState({memberIdToEdit:this.state.currentMemberData.id});
        this.setState({isEditAddMode:true});
    }

    editAndAddDone = (targetId) => {        
        this.setState({manipulateLayerState:'minimum'});
        this.getList().then(() => {            
            //リストからidを探して
            const memberData = this.state.members.find(data => 
                data.id === targetId
            );            
            this.setState({currentMemberData:memberData});
        });
    }

    //del
    deleteMember = () => {
        MemberControllerAPI.delete(this.state.currentMemberData.id)
        .then((result) => {
            this.props.onInfoDisplayCall('heartBreak','#999999','忘れました');
            this.deleteDone();
            this.toggleDeleteDialog()
        })
        .catch((error) => {
            this.toggleDeleteDialog()
        })
    }

    toggleDeleteDialog = () => {
        this.setState({isDeleteDialogShown:!(this.state.isDeleteDialogShown)})
    }

    deleteDone = () => {
        this.setState({manipulateLayerState:'max'});
        this.setState({
          currentMemberData:{}
        });
        this.getList().then(() => {
        });
    }

    //order
    changeToOrderMode = () => {
        //ワークモード切り替え
        this.setState({workMode:'orderMode'})
        this.setState({membersReserve:JSON.parse(JSON.stringify(this.state.members))})
    }

    cancelOrderMode = () => {
        this.setState({workMode:'displayMode'})
        this.setState({members:JSON.parse(JSON.stringify(this.state.membersReserve))})
    }

    submitNewOrder = () => {
        this.setState({workMode:'displayMode'});
        //member情報を取得
        MemberControllerAPI.order_store(this.state.members)
        .then((result) => {
            this.props.onInfoDisplayCall('facedHeart','hsl(6,77%,62%)','並び替えました');
            // this.setState({members:result.data});
            this.setState({membersReserve:[]})
        })
        .catch(function(error){
            console.log(error.message);
        });

    }

    changeOrder = (sortedMembers) => {
        this.setState({members:sortedMembers})
    }


    //manipulateLayer
    manipulateLayerModeChange = (state) => {
        if(this.state.manipulateLayerState !== state){
            this.setState({manipulateLayerState:state});
        }
    }


    render() {

        const themeColorBg = (themeColor) => {
            if(themeColor === null || themeColor === undefined) {
                themeColor = 'hsl(6,77%,62%)';
            }

            const splitArray = themeColor.split(',');
            let hue = splitArray[0].replace('hsl(','');
            let saturation = splitArray[1].replace('%','');
            let lightness = splitArray[2].replace('%)','');

            saturation = parseInt(saturation) - 30;
            lightness = 92;
            const newHslColor = 'hsl(' + hue + ',' + saturation + '%,' + lightness + '%)';
            return newHslColor;
        } 

        const layoutWholeClass = () => {
            let classStr = layerLayoutStyles['layoutWholeArea'];
            if(this.state.manipulateLayerState === 'max'){

                return classStr + ' ' + layerLayoutStyles['manipulateLayerMemberFull'];

            }else if(this.state.manipulateLayerState === 'middium'){

                return classStr + ' ' + layerLayoutStyles['manipulateLayerMiddium'];

            }else if(this.state.manipulateLayerState === 'minimum'){

                return classStr + ' ' + layerLayoutStyles['manipulateLayerMinimum'];
            }else if(this.state.manipulateLayerState === 'loading'){
              
                return classStr + ' ' + layerLayoutStyles['manipulateLayerLoading'];
            }
        }

        const manipuleteButton = (position,icon,clickEvent,exStyle) => {
            return (
                <CSSTransition
                in={this.state.manipulateLayerState !== 'minimum'}
                timeout={200}
                classNames="simpleFade200"
                unmountOnExit
                mountOnEnter
                >
                  <div className={layerLayoutStyles['manipulateButton'] + ' ' + layerLayoutStyles[position] + ' touchActivePush'}
                  style={exStyle === undefined ? null : {backgroundColor:exStyle.bgColor}}
                  onClick={clickEvent}
                  >
                    <div className={layerLayoutStyles['icon']}>
                      <SvgIconBaseComponent image={icon} fillColor={exStyle === undefined ? '#ffffff' : exStyle.color}/>
                    </div>
                  </div>
                </CSSTransition>
            )
        }

        return (
          <div className={layoutWholeClass()}>
            <div className={layerLayoutStyles['layoutMainArea']}>
              <div className={layerLayoutStyles['baseLayer']}
              style={{backgroundColor:themeColorBg(this.state.currentMemberData.color)}}
              >

                {this.state.members.map((memberData) => {
                    return (
                        <CSSTransition
                        in={memberData.id === this.state.currentMemberData.id}
                        timeout={200}
                        classNames="simpleFade200"
                        unmountOnExit
                        mountOnEnter
                        key={memberData.id}
                        >
                          <div className={layerLayoutStyles['absoluteElement']}
                          onClick={() => this.setState({manipulateLayerState:'minimum'})}
                          >
                            <MemberInfoSheet 
                            memberData={this.state.currentMemberData}
                            onEditButtonClick={this.editWindowShow}
                            onDelButtonClick={this.toggleDeleteDialog}
                            />
                          </div>
                        </CSSTransition>
                    )
                })}                  

              </div>

              <div className={layerLayoutStyles['manipulateLayer']}>

                <div className={layerLayoutStyles['manipulateLayerHeader']}
                onClick={() => {
                    if(this.state.manipulateLayerState === 'minimum'){
                        this.manipulateLayerModeChange('max');
                    }
                }}
                >
                  {this.state.manipulateLayerState === 'minimum' 
                  ? <div style={{width:'24px',height:'24px'}}>
                      <SvgIconBaseComponent image={'arrowUp'} fillColor={'#999999'} />
                    </div>
                  : <div>
                      <h2>
                        {this.state.workMode === 'displayMode' && 'メンバー'}
                        {this.state.workMode === 'orderMode' && 'ならびかえ'}
                      </h2>
                    </div>}
                </div>

                <div className={layerLayoutStyles['manipulateMain']}
                ref={this.manipulateScrollArea}
                >
                  <MemberGridListComponent 
                  currentWorkMode={this.state.workMode}
                  members={this.state.members}
                  gridButtonClickEvent={(data) => this.memberDataChange(data)}
                  onSortChange={(sortedMembers) => this.changeOrder(sortedMembers)}
                  />
                </div>

              </div>

              <CSSTransition
              in={this.state.workMode === 'displayMode'}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                {manipuleteButton('left','sort',this.changeToOrderMode)}
              </CSSTransition>
              <CSSTransition
              in={this.state.workMode === 'displayMode'}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                {manipuleteButton('right','add',this.addWindowShow)}
              </CSSTransition>
              <CSSTransition
              in={this.state.workMode === 'orderMode'}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                {manipuleteButton('left','cancel',this.cancelOrderMode,{color:'#555555',bgColor:'#ffffff'})}
              </CSSTransition>
              <CSSTransition
              in={this.state.workMode === 'orderMode'}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                {manipuleteButton('right','submit',this.submitNewOrder,{color:'hsl(93,54%,43%)',bgColor:'#ffffff'})}
              </CSSTransition>

            </div>


          <CSSTransition
          in={this.state.isEditAddMode}
          timeout={200}
          classNames="simpleFade200"
          unmountOnExit
          mountOnEnter
          >
            <div className={modalStyles['inputModalBase']}>
              <div className={modalStyles['modal']}>
                {/* <ThanksEditAndAdd
                thankId={this.state.thankIdToEdit}
                onSubmitDone={this.editAndAddDone}
                onCancelButtonClick={() => this.setState({isEditAddMode:false})}
                onDeleteDone={this.deleteDone}
                onInfoDisplayCall={this.props.onInfoDisplayCall}
                /> */}
                <MemberEditAndAddMode
                memberId={this.state.memberIdToEdit}
                onSubmitDone={this.editAndAddDone}
                onCancelButtonClick={() => this.setState({isEditAddMode:false})}
                onInfoDisplayCall={this.props.onInfoDisplayCall}
                />
              </div>
            </div>
          </CSSTransition>


          <CSSTransition
          in={this.state.isDeleteDialogShown}
          timeout={200}
          classNames="simpleFade200"
          unmountOnExit
          mountOnEnter
          >
            <DialogComponent 
            question={'本当に忘れますか？'}
            answers={[
                {display:'忘れる',isGhostStyle:false, onButtonClick:this.deleteMember},
                {display:'やめる', isGhostStyle:true, onButtonClick:this.toggleDeleteDialog}
            ]} 
            />
          </CSSTransition>


        </div>
    )
    }

};